import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EFieldType } from '../../../constants';
import { CardsQuestionContainer } from '../../CardsQuestionContainer';
import { CardsChoseQuestionContainer } from '../../CardsChoseQuestionContainer';
import { CheckboxFieldContainer } from '../../CheckboxFieldContainer';
import { FloatFieldContainer } from '../../FloatFieldContainer';
import { IntegerFieldContainer } from '../../IntegerFieldContainer';
import { PriceFieldContainer } from '../../PriceFieldContainer';
import { StringFieldContainer } from '../../StringFieldContainer';
import { TextareaFieldContainer } from '../../TextareaFieldContainer';
import { DateFieldContainer } from '../../DateFieldContainer';
import { MaskedFieldContainer } from '../../MaskedFieldContainer';
import { NumberFieldContainer } from '../../NumberFieldContainer';
import { SelectFieldContainer } from '../../SelectFieldContainer';
import { RadioGroupContainer } from '../../RadioGroupContainer';
import { RadioButtonGroupContainer } from '../../RadioButtonGroupContainer';
export var FieldMapper = /*#__PURE__*/function () {
  function FieldMapper(extendedMap) {
    var _this = this,
        _defaultFieldsMap;

    _classCallCheck(this, FieldMapper);

    _defineProperty(this, "_fieldsMap", void 0);

    _defineProperty(this, "_defaultFieldComponent", StringFieldContainer);

    _defineProperty(this, "_fieldMapper", function (fieldType) {
      return _this._fieldsMap[fieldType] || _this._defaultFieldComponent;
    });

    var defaultFieldsMap = (_defaultFieldsMap = {}, _defineProperty(_defaultFieldsMap, EFieldType.Float, FloatFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Integer, IntegerFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Price, PriceFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Number, NumberFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.String, StringFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.OneChoice, CardsQuestionContainer), _defineProperty(_defaultFieldsMap, EFieldType.MultiChoice, CardsChoseQuestionContainer), _defineProperty(_defaultFieldsMap, EFieldType.Checkbox, CheckboxFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Textarea, TextareaFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Date, DateFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Masked, MaskedFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.Select, SelectFieldContainer), _defineProperty(_defaultFieldsMap, EFieldType.RadioGroup, RadioGroupContainer), _defineProperty(_defaultFieldsMap, EFieldType.RadioButtonGroup, RadioButtonGroupContainer), _defaultFieldsMap);
    this._fieldsMap = Object.assign({}, defaultFieldsMap, extendedMap);
  }

  _createClass(FieldMapper, [{
    key: "fieldMapper",
    get: function get() {
      return this._fieldMapper;
    }
  }]);

  return FieldMapper;
}();